import * as helpers from './common/helpers';
import * as errors from './common/errors';
import type { Event } from './event';

export const createLog = (type: string, message: string, details?: string) => {
  let logMessage = `[usage-tracker-core "${type}"] ${message}`;

  if (details && details.trim().length > 0) {
    logMessage += `\n----------------------------------------\n${details}\n----------------------------------------`;
  }

  return logMessage;
};

export const createDebugLogger =
  (logMessage: (...msg: string[]) => void) =>
  (eventKey: string, message: string, event?: Event) => {
    const { where_app: namespace, what_event: name } = event || {};

    const eventType =
      `[${helpers.prettyPrint(namespace)}] ` + `${helpers.prettyPrint(name)}`;

    const eventDetails = `eventKey: ${eventKey}\neventType: ${eventType}`;

    const prettifiedPayload = JSON.parse(JSON.stringify(event || {}));

    prettifiedPayload.what_extra_json = JSON.parse(
      prettifiedPayload.what_extra_json || '{}'
    );

    logMessage(
      createLog('debug log', message, eventDetails),
      prettifiedPayload
    );
  };

export const createErrorLogger =
  (logError: (...e: any[]) => void, onError?: (...e: any[]) => void) =>
  (error: Error, options?: any) => {
    logError(error);

    helpers.ensureFn(onError)(error, options);
  };

export const createWarningLogger =
  (logWarning: (...w: any[]) => void, onWarning?: (...w: any[]) => void) =>
  (warning: Error, options?: any) => {
    logWarning(warning);

    helpers.ensureFn(onWarning)(warning, options);
  };

export const createPropertyResolutionFailedLogger =
  (
    logError: (...e: any[]) => void,
    logWarning: (...w: any[]) => void,
    onError?: (...e: any[]) => void
  ) =>
  (eventKey: string) =>
  (propertyName: string, error: Error) => {
    logError(error);

    const warningMessage = errors.genericWarning(
      `Property "${propertyName}" failed to resolve asynchronously and will fallback to "null".`
    );

    logWarning(warningMessage);

    helpers.ensureFn(onError)(error, {
      extra: { propertyName },
      fingerprint: [
        'usage-tracker-js',
        'tracker:failedResolveProperty',
        `event:${eventKey}`,
      ],
    });
  };
